import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'app/services/translate';
import {Button} from './button';
import {Observable} from 'rxjs';

export class Container extends Component {
    static get propTypes() {
        return {
            handleCitiesButtonClick$: PropTypes.instanceOf(Observable).isRequired,
            cities: PropTypes.arrayOf(PropTypes.object).isRequired,
        };
    }

    render() {
        return (
            <div className="map-buttons-container">
                <div className="btn-city-container">
                    <p className="description">{Translate('commons_agents_map_popular_cities')}</p>
                    <div className="btn-city-wrapper">
                        {this.props.cities.map((city, k) => (
                            <Button
                                onClick$={this.props.handleCitiesButtonClick$}
                                mapPosition={city.localization}
                                className="btn-city"
                                key={k}>{city.name}</Button>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}